module.exports = __webpack_public_path__ + "h5/img/manu2.2203fc4d.jpg";